import {
  GameList,
  GameProvider,
  GameStatus,
  GamesGamesClient,
  PopularGameList,
  Game,
  GameIdentifier,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gamesClient = new GamesGamesClient(apiConfig, undefined, axiosInstance);

interface GetAllGamesParams {
  page?: number;
  limit?: number;
  sort?: string;
  provider?: GameProvider;
  status?: GameStatus;
  category?: string;
}

const handleGetPopularGames = async ({
  limit,
  page,
}: Pick<GetAllGamesParams, "limit" | "page">): Promise<PopularGameList> => {
  return (await gamesClient.getAllPopularGames(limit, page)).data;
};

const handleGetGameDetails = async (gameId: string): Promise<Game> => {
  return (await gamesClient.getGameDetail(gameId)).data;
};

const handleGetGameDetailsBySlug = async (slug: string): Promise<Game> => {
  return (await gamesClient.getGameDetailBySlug(slug)).data;
};

const handleGetAllGames = async (
  params?: GetAllGamesParams
): Promise<GameList> => {
  const { page, limit, sort, provider, status, category } = params || {};

  return (
    await gamesClient.getAllGames(page, limit, sort, provider, status, category)
  ).data;
};

const handleGetMyTopGames = async (limit?: number, page?: number) => {
  return (await gamesClient.getMyTopGames(limit, page)).data;
};

const handleGetMyChallengeInvitationDefaultGame =
  async (): Promise<GameIdentifier> => {
    return (await gamesClient.getChallengeInvitationDefaultGame()).data;
  };

export {
  handleGetPopularGames,
  handleGetGameDetails,
  handleGetGameDetailsBySlug,
  handleGetAllGames,
  GetAllGamesParams,
  handleGetMyTopGames,
  handleGetMyChallengeInvitationDefaultGame,
};
